export const environment = {
  authorization: {
    issuer: 'https://sso.myshareview.com',
    clientId: 'shareview-clinician',
    scope: 'openid profile offline_access roles shareview',
  },
  apiBaseUrl: 'https://api.myshareview.com',
  appId: 4,
  environment: 'prod',
  signalR: {
    hubPath: '/ShareViewHub',
  },
  teleEngine: {
    environment: 'production'
  },
};
